import PropTypes from 'prop-types';
import React from 'react';
import { FormControl } from 'react-bootstrap';


export class AppointmentFilterDropdown extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: JSON.stringify(this.props.value),
    };
  }

  reset = () => {
    this.state.value = JSON.stringify(this.props.defaultOptionValue);
  }

  buildDropdownOption = (option) => {
    const optValue = JSON.stringify(option.optionValue);
    return (
      <option
        key={optValue}
        value={optValue}
      >
        {option.optionText}
      </option>
    );
  }

  handleOnChange = (event) => {
    this.setState({ value: event.target.value });

    const optionValue = JSON.parse(event.target.value);
    this.props.handleChangeEvent(optionValue);
  }

  render() {
    const selectOptions = this.props.options ?
      this.props.options.map(this.buildDropdownOption) :
      [];
    const { defaultOptionValue, handleChangeEvent, options, ...restOfProps } = this.props;
    return (
      <FormControl
        componentClass="select"
        {...restOfProps}
        onChange={this.handleOnChange}
        value={this.state.value}
      >
        {selectOptions}
      </FormControl>
    );
  }
}

AppointmentFilterDropdown.propTypes = {
  id: PropTypes.string,
  defaultOptionValue: PropTypes.object,
  value: PropTypes.object,
  options: PropTypes.array,
  handleChangeEvent: PropTypes.func,
  className: PropTypes.string,
};
